'use client';

import { useEffect, useRef } from 'react';

export default function CoreValueSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef?.current?.querySelectorAll('.reveal, .reveal-scale');
    elements?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  const cards = [
  {
    emoji: '🖥️',
    color: '#FF3008',
    bgColor: '#FFF5F5',
    title: 'Real-Time Screen Sharing',
    desc: 'Work side-by-side with your Genie. No Zoom, no Google Meet — screen sharing is built directly into the session.',
    tag: 'Zero Setup',
    delay: '0s'
  },
  {
    emoji: '🧞',
    color: '#6C5CE7',
    bgColor: '#F0EDFF',
    title: 'Experts Available Instantly',
    desc: 'Skip proposals, interviews, and waiting. Describe your need and get matched with a qualified Genie in under 60 seconds.',
    tag: '< 60 Seconds',
    delay: '0.1s'
  },
  {
    emoji: '⚡',
    color: '#FFB800',
    bgColor: '#FFFBEB',
    title: 'Instant Payouts',
    desc: 'Funds held in secure escrow. The moment you approve the work, your Genie gets paid instantly — no 30-day wait.',
    tag: 'Escrow Protected',
    delay: '0.2s'
  }];


  return (
    <section ref={sectionRef} className="py-20 lg:py-28 px-4 sm:px-6 bg-surface">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 reveal">
          <p className="text-xs font-bold uppercase tracking-widest text-muted mb-3">Why Summons Works</p>
          <h2 className="text-4xl sm:text-5xl font-black text-foreground tracking-tight leading-tight">
            Built Different.<br />
            <span className="text-[rgba(255,48,8,1)]">By Design.</span>
          </h2>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {cards?.map((card, i) =>
          <div
            key={i}
            className="reveal-scale bg-white rounded-3xl p-8 shadow-card border border-border benefit-card relative overflow-hidden"
            style={{ transitionDelay: card?.delay }}>

              {/* Background accent */}
              <div
              className="absolute top-0 right-0 w-32 h-32 rounded-full blur-3xl opacity-20"
              style={{ background: card?.color }} />


              {/* Icon */}
              <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center text-2xl mb-6 relative"
              style={{ background: card?.bgColor }}>

                {card?.emoji}
              </div>

              {/* Tag */}
              <div
              className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-4"
              style={{ background: card?.bgColor, color: card?.color }}>

                {card?.tag}
              </div>

              <h3 className="text-xl font-bold text-foreground mb-3 leading-tight">{card?.title}</h3>
              <p className="text-sm text-muted leading-relaxed">{card?.desc}</p>
            </div>
          )}
        </div>
      </div>
    </section>);

}